import { render, staticRenderFns } from "./customComponent.vue?vue&type=template&id=8f86e0a2&scoped=true&"
import script from "./customComponent.vue?vue&type=script&lang=js&"
export * from "./customComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f86e0a2",
  null
  
)

export default component.exports